module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-3-d380f324da111a10dc02fbb1f77c70cc.png";